import OriginValues from "./origin-values.enum";

const relations = [
  {
    value: "0",
    options: [
      "0",
      "00",
      "zero",
      "0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8"
    ]
  },
  {
    value: "1",
    options: [
      "1",
      "01",
      "um",
      "1 - Estrangeira - Importação direta, exceto a indicada no código 6"
    ]
  },
  {
    value: "2",
    options: [
      "2",
      "02",
      "dois",
      "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7"
    ]
  },
  {
    value: "3",
    options: [
      "3",
      "03",
      "três",
      "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%"
    ]
  },
  {
    value: "4",
    options: [
      "4",
      "04",
      "quatro",
      "4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/67, e as Leis nºs 8.248/91, 8.387/91, 10.176/01 e 11.484/07"
    ]
  },
  {
    value: "5",
    options: [
      "5",
      "05",
      "cinco",
      "5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%"
    ]
  },
  {
    value: "6",
    options: [
      "6",
      "06",
      "seis",
      "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista da CAMEX"
    ]
  },
  {
    value: "7",
    options: [
      "7",
      "07",
      "sete",
      "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista da CAMEX"
    ]
  },
  {
    value: "8",
    options: [
      "8",
      "08",
      "oito",
      "8 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 70% (setenta por cento)"
    ]
  }
];

export default raw_unit => {
  const unit = `${raw_unit}`;

  if (OriginValues[unit]) {
    return unit;
  }

  for (const relation of relations) {
    if (relation && relation.options.includes(unit)) {
      return relation.value;
    }
  }

  return "none";
};



// WEBPACK FOOTER //
// ./src/core/enum/origin-relationships.enum.js